module.exports = __webpack_public_path__ + "img/nav-covid-dark.90a302a5.svg";